import * as React from "react";

import { GuidedTour, GuidedTourProps } from "@/components/guide/GuidedTour";

const AppTour: React.FC<GuidedTourProps> = props => <GuidedTour {...props} disableCloseOnEsc />;

export default AppTour;
